import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRefresh = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M10 .314c-5.514 0-10 4.486-10 10 0 2.147.681 4.138 1.838 5.77L.803 17.105a.595.595 0 0 0 .415 1.018l3.726.016c.436 0 .791-.35.795-.784l.034-3.727A.594.594 0 0 0 4.76 13.2l-1.048 1.035a7.348 7.348 0 0 1-1.132-3.922c0-4.091 3.328-7.42 7.42-7.42 4.091 0 7.42 3.328 7.42 7.42 0 3.12-1.936 5.786-4.668 6.878-.581.233-.915.847-.794 1.461a1.286 1.286 0 0 0 1.737.943C17.385 18.123 20 14.522 20 10.313c0-5.513-4.486-10-10-10Z" })
});
export default SvgRefresh;
